import { Carousel } from '@devotel/design-system';
import styled from 'styled-components';

export const StyledCarousel = styled(Carousel)`
  height: 100% !important;
  .slick-list,
  .slick-track,
  .slick-slide,
  .slick-slide > div {
    height: 100% !important;
  }

  .slick-dots li button::after {
    content: none !important;
  }

  .slick-dots li {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin: 0 4px;
  }

  .slick-dots li button {
    background-color: #fecbbb !important;
  }

  .slick-dots li button::after {
    content: none !important;
  }

  .slick-dots li.slick-active button {
    background: #fd5b2c !important;
  }
`;
